import {inlineError} from '@s-ui/decorators'

import {PageRepository} from './PageRepository.js'

/**
 * @class
 * @implements PageRepository
 */
export class ClientPageRepository extends PageRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.urlValueObjectFactory
   */
  constructor({urlValueObjectFactory}) {
    super()
    this._urlValueObjectFactory = urlValueObjectFactory
  }

  @inlineError
  async getCurrentUrl() {
    const fullUrl = `${window.location.pathname}${window.location.search}`
    return this._urlValueObjectFactory({url: fullUrl})
  }
}
